import { VStack } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { Course } from "../../const/types";
import ComponentSpinner from "../ComponentSpinner";
import CourseEditUmumForm from "./CourseEditUmumForm";
import { useParams } from "react-router-dom";
import cr from "../../lib/request";
import useTrigger from "../../globalState/useTrigger";

export default function CourseUmumEdit() {
  const [data, setData] = useState<Course | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const { id } = useParams();
  const { trigger } = useTrigger();

  useEffect(() => {
    if (id) {
      setLoading(true);
      const url = `api/course/${id}/showdetail`;
      cr.get(url)
        .then((r) => {
          if (r.status === 200) {
            setData(r.data.data);
          }
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [id, trigger]);

  return (
    <VStack flex={1} align={"stretch"} gap={0}>
      {!loading && data ? (
        <>
          <CourseEditUmumForm data={data} />
        </>
      ) : (
        <ComponentSpinner />
      )}
    </VStack>
  );
}
